import React, { useState, useEffect } from 'react';
import TabPage from 'components/common/TabPage';
import { Spinner } from 'react-bootstrap';
import loader from '../../assets/img/loader.svg'

const tabArray = ['Client List'];

export const ClientDetailList = () => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        $("#btnNew").hide();
    }, [])

    const exitModule = () => {
        window.location.href = '/dashboard';
    }

    return (
        <>
            {/* {isLoading ? (
                <Spinner
                  className="loader-color popup-loader position-fixed top-50 start-50 translate-middle z-index-5"
          // className="position-absolute start-50 loader-color"
                    animation="border"
                />
            ) : null} */}
                  {isLoading ? (
  <img
    src={loader}
    alt="Loading..."
    className="loader-gif position-fixed top-50 start-50 translate-middle z-index-5"
  />
) : null}

            <TabPage
                tabArray={tabArray}
                module='ClientDetailList'
                exitModule={exitModule}
            />
        </>
    )
}
export default ClientDetailList;